<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <b-icon icon="clipboard" class="mLeft"></b-icon>
          <span>Reportes</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>CÓDIGO: PR_01</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="subtitulos-interno">
            <b-row>
              <b-col class="seccionTituloSubTitulo">
                <span>Datos del reporte</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12">

          <b-row align-v="center" align-h="end">
            <b-col cols="3">
              <label>Reporte: </label>
                <b-input-group lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="clipboard"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      id="padre"
                      name="padre"
                      placeholder="Selecciones un reporte"
                      :options="listaVistas"
                      :reduce="(item) => item"
                      v-model="selecionado"
                      label="nombreVista"
                      style="width: 70%"
                      @input="agregarvista()"
                  >
                    <span slot="no-options">No hay valores disponibles</span>
                  </v-select>
                </b-input-group>
            </b-col>
            <b-col cols="9">
                <label for="padre">Datos del reporte: </label>
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      id="trtsg"
                      name="trtsg"
                      placeholder="Selecione los datos del reporte"
                      multiple
                      :options="listaColumnas"
                      v-model="filtrosAgregar"
                      label="nombreColumna"
                      @input="verificando()"
                      style="width: 80%"
                  ><span slot="no-options">No hay valores disponibles</span>
                  </v-select>
                  <b-button
                      v-if="listaColumnas.length > 0"
                      class="ml-1"
                      variant="outline-primary"
                      v-b-tooltip.hover
                      title="Seleccionar Todos"
                      @click="seleccionarTodos()">
                    <b-icon icon="check2-all"></b-icon>
                  </b-button>
                  <b-button
                      v-if="listaColumnas.length > 0"
                      class="ml-1"
                      variant="outline-primary"
                      v-b-tooltip.hover
                      title="Seleccionar Ninguno"
                      @click="agregarvista()">
                    <b-icon icon="clipboard-x"></b-icon>
                  </b-button>
                </b-input-group>

                <b-form-checkbox v-model="contar" switch>
                  <Strong>¿Contar?</Strong>
                </b-form-checkbox>

            </b-col>
          </b-row>

          <div class="mt-2 col-md-12"></div>

          <b-row>
            <b-col cols="6">
              <div class="subtitulos-interno">
                <b-row>
                  <b-col class="seccionTituloSubTitulo">
                    <span>Filtros</span>
                  </b-col>
                  <b-col class="seccionCodigoSubTitulo">
                    <div>
                      <b-button
                          v-if="filtrosAgregar.length > 0"
                          v-b-tooltip.hover
                          title="Agregar Orden"
                          variant="success"
                          @click="agregar()">Agregar Filtros
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col v-if="filtrosAgregar.length == 0 || listaFiltros.length == 0">
                  <b-alert
                      variant="warning" show>No hay Filtros
                  </b-alert>
                </b-col>
                <b-col v-if="listaFiltros.length > 0">
                  <b-form-group
                      class="mt-3"
                      align="left"
                      v-for="(col, index) in listaFiltros"
                      :key="col.idcolumna"
                  >
                    <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                      <b-button
                          size="sm"
                          v-b-tooltip.hover
                          title="Eliminar"
                          variant="outline-danger"
                          @click="eliminarFiltro(index)"
                          class="mr-1"
                      >
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                      <b-button
                          size="sm"
                          v-b-tooltip.hover
                          title="Modificar"
                          variant="outline-warning"
                          @click="editarFiltro(index)"
                          class="mr-1"
                      ><em class="fa fa-pencil"></em>
                      </b-button>
                      <b-input-group-prepend is-text>
                        <b>{{ col.columna }}</b>
                      </b-input-group-prepend>
                      <b-input-group-prepend is-text>
                        <b>{{ col.operador }}</b>
                      </b-input-group-prepend>
                      <b-input-group-prepend is-text>
                        <b>{{ col.valor }}</b>
                      </b-input-group-prepend>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <div class="subtitulos-interno">
                <b-row>
                  <b-col class="seccionTituloSubTitulo">
                    <span>Orden</span>
                  </b-col>
                  <b-col class="seccionCodigoSubTitulo">
                    <div>
                      <b-button
                          v-if="filtrosAgregar.length > 0"
                          v-b-tooltip.hover
                          title="Agregar Orden"
                          variant="success"
                          @click="agregarOrden()">Agregar Orden
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col
                    v-if="
            listaAsc.length === 0 &&
            listaDesc.length === 0 &&
            listaAgroup.length === 0
          "
                    class="mt-2 col-6">
                  <b-alert variant="warning" show>No hay Orden</b-alert>
                </b-col>
                <b-col v-if=" listaAsc.length !== 0 ||
            listaDesc.length !== 0 ||
            listaAgroup.length !== 0"
                       class="col-6">
                  <div v-if="listaAsc.length > 0" class="mt-2">
                    <label
                    >ORDENAR ASC
                      <b-button
                          size="sm"
                          v-b-tooltip.hover
                          title="Eliminar"
                          variant="outline-danger"
                          @click="eliminarFiltroCompleto(1)"
                          class="mr-1"
                      >
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                    </label>
                    <b-list-group
                        v-for="(col, index) in listaAsc"
                        :key="col.idcolumna"
                        class="mb-2"
                    >
                      <b-list-group-item>
                        <b-button
                            size="sm"
                            v-b-tooltip.hover
                            title="Eliminar"
                            variant="outline-danger"
                            @click="eliminarOrden(index, 1)"
                            class="mr-1"
                        >
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                        <b-button
                            size="sm"
                            v-b-tooltip.hover
                            title="Modificar"
                            variant="outline-warning"
                            @click="editarOrden(index, 1)"
                            class="mr-1"
                        ><em class="fa fa-pencil"></em>
                        </b-button>
                        {{ col.columna }}
                      </b-list-group-item
                      >
                    </b-list-group>
                  </div>
                  <div v-if="listaDesc.length > 0" class="mt-2">
                    <label
                    >ORDENAR DESC
                      <b-button
                          size="sm"
                          v-b-tooltip.hover
                          title="Eliminar"
                          variant="outline-danger"
                          @click="eliminarFiltroCompleto(2)"
                          class="mr-1"
                      >
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                    </label>
                    <b-list-group
                        v-for="(col, index) in listaDesc"
                        :key="col.idcolumna"
                        class="mb-2"
                    >
                      <b-list-group-item>
                        <b-button
                            size="sm"
                            v-b-tooltip.hover
                            title="Eliminar"
                            variant="outline-danger"
                            @click="eliminarOrden(index, 2)"
                            class="mr-1"
                        >
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                        <b-button
                            size="sm"
                            v-b-tooltip.hover
                            title="Modificar"
                            variant="outline-warning"
                            @click="editarOrden(index, 2)"
                            class="mr-1"
                        ><em class="fa fa-pencil"></em>
                        </b-button>
                        {{ col.columna }}
                      </b-list-group-item
                      >
                    </b-list-group>
                  </div>
                  <div v-if="listaAgroup.length > 0" class="mt-2">
                    <label
                    >GROUP BY
                      <b-button
                          size="sm"
                          v-b-tooltip.hover
                          title="Eliminar"
                          variant="outline-danger"
                          @click="eliminarFiltroCompleto(3)"
                          class="mr-1"
                      >
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                    </label>
                    <b-list-group
                        v-for="(col, index) in listaAgroup"
                        :key="col.idcolumna"
                        class="mb-2"
                    >
                      <b-list-group-item>
                        <b-button
                            size="sm"
                            v-b-tooltip.hover
                            title="Eliminar"
                            variant="outline-danger"
                            @click="eliminarOrden(index, 3)"
                            class="mr-1"
                        >
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                        {{ col.nombreColumna }}
                      </b-list-group-item
                      >
                    </b-list-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>

      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row>
          <b-col cols="12">
            <div class="subtitulos-interno">
              <b-row>
                <b-col class="seccionTituloSubTitulo">
                  <span>Reporte</span>
                </b-col>
                <b-col class="seccionCodigoSubTitulo">
                  <b-button variant="success" @click="reporte()"
                            :disabled="!blnBtnGenerar || filtrosAgregar.length<=0">
                    <span v-if="blnBtnGenerar">Genera reporte</span>
                    <span v-if="!blnBtnGenerar">
                    <b-spinner small></b-spinner>
                    Cargando...
                  </span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>

          <b-col cols="12" class="mt-2" v-if="existeDatos">
            <b-alert variant="warning" show>No hay datos</b-alert>
          </b-col>

          <b-col cols="12">
            <b-tabs content-class="mt-3" v-if="!existeDatos && blnBtnGenerar">
              <b-tab title="Tabla" active>
                <b-row class="ml-1 mr-1">
                  <b-table
                      id="Pendientes"
                      thead-tr-class="columnas"
                      :current-page="paginaActual"
                      :fields="fields"
                      :items="datosTabla"
                      :per-page="$registrosPorPaginaTabla"
                      responsive
                      class="parrafos"
                      hover
                      sticky-header="400px"
                      small
                  >
                  </b-table>
                  <b-col v-if="!loaderTabla">
                    <b-pagination
                        v-if="datosTabla !== undefined"
                        align="center"
                        v-model="paginaActual"
                        :total-rows="datosTabla.length"
                        :per-page="registrosPorPagina"
                        aria-controls="my-table1"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Gráfica">
                <b-row>
                  <b-col class="col-5">
                    <b-form-group align="left" class="mt-3">
                      <label for="columnax"> Columna X</label>
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="menu-button-wide-fill"></b-icon>
                        </b-input-group-prepend>
                        <v-select
                            id="columnax"
                            name="columnax"
                            placeholder="Selecione las columna X"
                            :options="filtrosAgregar"
                            v-model="listaGraficaX"
                            label="nombreColumna"
                            @input="columnVerificarX()"
                            style="width: 70%"
                        ><span slot="no-options">No hay valores disponibles</span>
                        </v-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-5">
                    <b-form-group align="left" class="mt-3">
                      <label for="columnay"> Columna Y</label>
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="menu-button-wide-fill"></b-icon>
                        </b-input-group-prepend>
                        <v-select
                            id="columnay"
                            name="columnay"
                            placeholder="Selecione las columna Y"
                            :options="listaGraficaY"
                            v-model="columnSeleccionadoY"
                            label="nombreColumna"
                            style="width: 70%"
                        ><span slot="no-options">No hay valores disponibles</span>
                        </v-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-button
                        class="mt-4"
                        v-b-tooltip.hover
                        title="genera gráfica"
                        variant="outline-primary"
                        @click="generarGrafica()"
                    >Generar Gráfica
                    </b-button>
                  </b-col>
                </b-row>
                <div v-if="mostrarGrafica" style="background-color: #ffffff !important;">
                  <GraficaReporte :columnaX="columnaxTO" :columnaY="columnayTO" :nombrex="datoColumnaX"/>
                </div>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>

    </b-container>
    <b-modal v-model="show" :title="tituloModal" size="lg">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="columna">Columna</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      id="columna"
                      name="columna"
                      placeholder="Columna"
                      style="width: 95%"
                      v-model="columnafiltrada.columna"
                      :reduce="(item) => item"
                      label="nombreColumna"
                      :options="listaColumnas"
                      @input="columnaSeleccionado($event)"
                  ></v-select>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label for="operador">Operador</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      id="operador"
                      name="operador"
                      placeholder="Operador"
                      style="width: 95%"
                      v-model="columnafiltrada.operador"
                      :reduce="(item) => item.operador"
                      label="operador"
                      :options="operadores"
                  ></v-select>
                </b-input-group>
              </b-form-group>
              <b-form-group
                  align="left"
                  v-if="
                  (tipo !== '' && tipo == 'bigint') ||
                  tipo == 'integer' ||
                  tipo == 'double precision'
                "
              >
                <label for="valor"
                >Valor
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="list-nested"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                      id="valor"
                      name="valor"
                      placeholder="Ingrese un valor"
                      type="number"
                      v-model="$v.columnafiltrada.valor.$model"
                      :state="validateState('valor')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group
                  align="left"
                  v-if="
                  (tipo !== '' && tipo == 'character varying') || tipo == 'text'
                "
              >
                <label for="valortex"
                >Valor
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="list-nested"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                      id="valortex"
                      name="valortex"
                      placeholder="Ingrese un valor"
                      type="text"
                      v-model="$v.columnafiltrada.valor.$model"
                      :state="validateState('valor')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group> {{tipo}}
              <b-form-group
                  align="left"
                  v-if="tipo !== '' && (tipo == 'date' || tipo == 'timestamp without time zone')"
              >
                <label for="fcf">Fecha</label>
                <validacion/>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Ingrese una Fecha"
                      v-model="$v.columnafiltrada.valor.$model"
                      :state="validateState('valor')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
              <b-form-group
                  align="left"
                  v-if="tipo !== '' && tipo == 'boolean'"
              >
                <label for="fcf">Valor</label>
                <validacion/>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-checkbox
                      v-model="$v.columnafiltrada.valor.$model"
                      :state="validateState('valor')"
                      name="check-button"
                      switch
                  >
                  </b-form-checkbox>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" @click="obtenerDatos()">
          <span>Agregar</span>
        </b-button>
        <b-button variant="outline-danger" @click="cerrarModal()"
        >Cancelar
        </b-button
        >
      </div>
    </b-modal>
    <b-modal
        v-model="showAgrupamiento"
        :title="tituloModalAgrupamiento"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="columna">Orden y agrupación</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      name="columnaorden"
                      placeholder="ordena"
                      style="width: 95%"
                      label="ordenamiento"
                      :options="filtrosOrdenar"
                      v-model="columnaOrdenar.ordena"
                      :reduce="(item) => item.ordenamiento"
                      @input="validarSelect()"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
            <b-form v-if="valSelect">
              <b-form-group align="left">
                <label for="columna">Columnas</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      id="columnaorden"
                      name="columnaorden"
                      placeholder="Columna"
                      style="width: 95%"
                      :options="listaColumnasDisponibles"
                      label="nombreColumna"
                      :reduce="(item) => item.nombreColumna"
                      v-model="columnaOrdenar.columna"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
            <b-form v-if="!valSelect">
              <b-form-group align="left">
                <label for="columnaSelect"> Columnas</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      id="columnaSelect"
                      name="columnaSelect"
                      placeholder="Selecione las columnas"
                      multiple
                      :options="filtrosAgregar"
                      :reduce="(item) => item"
                      v-model="listAux"
                      label="nombreColumna"
                      style="width: 70%"
                  ><span slot="no-options">No hay valores disponibles</span>
                  </v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" @click="agregarOdern()">
          <span>Agregar</span>
        </b-button>
        <b-button variant="outline-danger" @click="cerrarModalOrden()"
        >Cancelar
        </b-button
        >
      </div>
    </b-modal>
    <b-modal
        v-model="showAgrupamientoEditar"
        :title="tituloModalAgrupamientoEditar"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label for="columna">Columnas</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      name="columnaorden"
                      placeholder="Columna"
                      style="width: 95%"
                      :options="listaColumnasDisponibles"
                      label="nombreColumna"
                      :reduce="(item) => item.nombreColumna"
                      v-model="columnaOrdenar.columna"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
            <b-form>
              <b-form-group align="left">
                <label for="columna">Orden</label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide-fill"></b-icon>
                  </b-input-group-prepend>
                  <v-select
                      name="columnaorden"
                      placeholder="ordena"
                      style="width: 95%"
                      label="ordenamiento"
                      :options="filtrosOrdenarEditar"
                      v-model="columnaOrdenar.ordena"
                      :reduce="(item) => item.ordenamiento"
                  ></v-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" @click="guardarOrdenEditar()">
          <span>Agregar</span>
        </b-button>
        <b-button variant="outline-danger" @click="cerrarModalOrdenEditar()"
        >Cancelar
        </b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
import Header from "../components/Header.vue";
import {required} from "vuelidate/lib/validators";
import XLSX from 'xlsx';
import GraficaReporte from "../components/GraficaReporte.vue";
export default {
  name: "Reporte",
  components: {
    Header,
    GraficaReporte
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    contar: false,
    operadores: [
      {
        idoperador: 1,
        operador: ">",
      },
      {
        idoperador: 2,
        operador: "<",
      },
      {
        idoperador: 3,
        operador: ">=",
      },
      {
        idoperador: 4,
        operador: "<=",
      },
      {
        idoperador: 5,
        operador: "<>",
      },
      {
        idoperador: 6,
        operador: "=",
      },
      {
        idoperador: 6,
        operador: "Like",
      },
    ],
    filtrosOrdenar: [
      {
        idfiltro: 1,
        agrupamiento: "ORDER BY ASC",
        columnas: [],
        agrupa: "ORDER BY",
        ordenamiento: "ASC",
      },
      {
        idfiltro: 2,
        agrupamiento: "ORDER BY DESC",
        columnas: [],
        agrupa: "ORDER BY",
        ordenamiento: "DESC",
      },
      {
        idfiltro: 3,
        agrupamiento: "GROUP BY",
        columnas: [],
        agrupa: "GROUP BY",
        ordenamiento: "GROUP BY",
      },
    ],
    filtrosOrdenarEditar: [
      {
        idfiltro: 1,
        agrupamiento: "ORDER BY ASC",
        columnas: [],
        agrupa: "ORDER BY",
        ordenamiento: "ASC",
      },
      {
        idfiltro: 2,
        agrupamiento: "ORDER BY DESC",
        columnas: [],
        agrupa: "ORDER BY",
        ordenamiento: "DESC",
      },
    ],
    selecionado: [],
    filtrosAgregar: [],
    aux: 1,
    mostrarAgrupamiento: false,
    columnafiltrada: {
      agrupa: "true",
      columna: null,
      operador: null,
      ordena: "ASC",
      tipo_dato: null,
      valor: null,
      gruop: "false",
      vista: null,
    },
    listaVistas: [],
    listaColumnas: [],
    fields: [],
    tituloModal: "",
    show: false,
    showAgrupamiento: false,
    tituloModalAgrupamiento: "",
    showAgrupamientoEditar: false,
    tituloModalAgrupamientoEditar: "",
    tipo: "",
    listaFiltros: [],
    loaderTabla: false,
    posicion: null,
    posicionOrden: null,
    listaAsc: [],
    listaDesc: [],
    listaAgroup: [],
    mostraTabla: false,
    datosTabla: [],
    paginaActual: 1,
    existeDatos: true,
    columnaOrdenar: {
      columna: null,
      ordena: null,
    },
    listaColumnasDisponibles: [],
    ordenaAux: null,
    valSelect: false,
    listAux: [],
    blnBtnGenerar: true,
    mostrarGrafica: false,
    columnSeleccionadoX: [],
    columnSeleccionadoY: [],
    listaGraficaX: [],
    listaGraficaY: [],
    muestraTabsGrafica: true,
    columnaxTO: [],
    columnayTO: [],
    registrosPorPagina: 10,
    datoColumnaX: null,
  }),
  validations: {
    columnafiltrada: {
      columna: {required},
      operador: {required},
      valor: {required},
    },
  },
  created() {
    this.obtenerVistas();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    exportarExcel() {
      let data = XLSX.utils.json_to_sheet(this.datosTabla)
      const workbook = XLSX.utils.book_new()
      const filename = 'reporte'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    obtenerVistas() {
      this.$http.get(this.$api + "reportes/vista_reporte").then((respuesta) => {
        if (respuesta.data.data) {
          this.listaVistas = respuesta.data.data;
        }
      });
    },
    obtenerColumnasVista(idvista) {
      this.$http
          .get(this.$api + "reportes/tablas_vista?idVista=" + idvista)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaColumnas = respuesta.data.data;
            }
          });
    },
    obtenenerColumnas(listaColumnas, listaFiltros) {
      this.blnBtnGenerar = false;
      this.$http
          .post(this.$api + "reportes/consultar_query", {"listaObjects": listaColumnas, "listaFiltros": listaFiltros, "contar": this.contar})
          .then((respuesta) => {
            this.blnBtnGenerar = true;

            if (this.contar) {
              listaColumnas.push({"columna":"total_conteo"});
            }

            if (respuesta.data.data && respuesta.data.data.length > 0) {
              const datos = respuesta.data.data;
              if (listaColumnas.length === 1) {
                let nombreColumna = listaColumnas[0].columna;
                let listaAux = [];
                if (listaColumnas[0].tipo_dato === 'date' || listaColumnas[0].tipo_dato === 'timestamp without time zone') {
                  for (let g = 0; g < datos.length; g++) {
                    let fecha = this.$moment(datos[g]).format('YYYY/MM/DD');
                    listaAux.push({[nombreColumna]: fecha});
                  }
                } else {
                  for (let g = 0; g < datos.length; g++) {
                    listaAux.push({[nombreColumna]: datos[g]});
                  }
                }
                this.datosTabla = listaAux;
              } else {
                let listaAuxiar = [];
                for (let j = 0; j < datos.length; j++) {
                  for (let i = 0; i < listaColumnas.length; i++) {
                    if (listaColumnas[i].tipo_dato === 'date' || listaColumnas[0].tipo_dato === 'timestamp without time zone') {
                      let fecha = this.$moment(datos[j][i]).format('YYYY/MM/DD');
                      listaAuxiar.push({[listaColumnas[i].columna]: fecha});
                    } else {
                      listaAuxiar.push({[listaColumnas[i].columna]: datos[j][i]});
                    }
                  }
                }
                let numero = 1;
                let listaAux = [];
                let listaAuxi = [];
                for (let index = 0; index < listaAuxiar.length; index++) {
                  if (numero < listaColumnas.length + 1) {
                    listaAux.push(listaAuxiar[index]);
                    numero++;
                  } else {
                    let campos = Object.assign.apply(Object, [{}].concat(listaAux));
                    listaAuxi.push(campos);
                    numero = 1;
                    listaAux = [];
                  }
                }

                this.datosTabla = listaAuxi;
              }


              if (respuesta.data.data.length == 0) {
                this.existeDatos = true;
              } else {
                this.existeDatos = false;
              }
              if (respuesta.data.data == null) {
                this.existeDatos = true;
                this.loaderTabla = false;
              }
              this.crearFields();
            }
            if (respuesta.data.data == null || respuesta.data.data.length === 0) {
              this.existeDatos = true;
              this.loaderTabla = false;
            }
          })
          .catch(error => {
            console.error(error.response.message);
            this.blnBtnGenerar = true;
          }).finally(() => {
        this.blnBtnGenerar = true;
      });
    },
    crearFields() {
      this.fields = [];
      for (let index = 0; index < this.filtrosAgregar.length; index++) {
        this.fields.push({
          key: this.filtrosAgregar[index].nombreColumna,
          sortable: true,
        });
      }

      if (this.fields.length > 0) {

        if (this.contar) {
          this.fields.push({
            key: "total_conteo",
            sortable: true,
          });
        }

        this.mostraTabla = true;
        this.loaderTabla = false;
      }
    },
    agregarvista() {
      this.contar = false;
      this.listaFiltros = [];
      this.filtrosAgregar = [];
      this.mostrarAgrupamiento = false;
      this.obtenerColumnasVista(this.selecionado.idVistaReportePermiso);
      this.datosTabla = [];
      this.listaAsc = [];
      this.listaDesc = [];
      this.listaAgroup = [];
      this.listaColumnasDisponibles = [];
      this.mostraTabla = false;
      this.mostrarGrafica = false;
      this.columnSeleccionadoX = [];
      this.columnSeleccionadoY = [];
      this.listaGraficaX = [];
      this.listaGraficaY =[];
      this.muestraTabsGrafica = true;
      this.columnaxTO = [];
      this.columnayTO =  [];
    },
    eliminarFiltro(i) {
      //this.filtrosAgregar.splice(i, 1);
      this.listaFiltros.splice(i, 1);
    },
    editarFiltro(i) {
      this.posicion = i;
      this.tituloModal = "Modificar Filtro";
      this.show = true;
      this.columnafiltrada = JSON.parse(JSON.stringify(this.listaFiltros[i]));
      this.tipo = this.listaFiltros[i].tipo_dato;
    },
    agregar() {
      this.columnafiltrada = {
        agrupa: "true",
        columna: null,
        operador: null,
        ordena: "ASC",
        tipo_dato: null,
        valor: null,
        gruop: "false",
        vista: null,
      };
      this.tipo = "";
      this.tituloModal = "Crear Filtro";
      this.show = true;
    },
    columnaSeleccionado(evento) {
      this.tipo = "";
      this.columnafiltrada.valor = null;
      this.columnafiltrada.operador = null;
      this.columnafiltrada.vista = null;
      this.tipo = evento.tipoDeDato;
      this.columnafiltrada.columna = evento.nombreColumna;
      this.columnafiltrada.vista = evento.nombreVista;
      this.columnafiltrada.tipo_dato = evento.tipoDeDato;
    },
    cerrarModal() {
      this.show = false;
    },
    obtenerDatos() {
      this.$v.columnafiltrada.$touch();
      if (this.columnafiltrada.columna == null) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar una columna para realizar el filtro ",
        });
      } else if (this.columnafiltrada.operador == null) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar un operador para realizar el filtro",
        });
      } else {
        if (!this.$v.columnafiltrada.$invalid) {
          if (this.posicion == null) {
            this.listaFiltros.push(this.columnafiltrada);
            this.cerrarModal();
          } else {
            this.listaFiltros[this.posicion] = this.columnafiltrada;
            this.cerrarModal();
            this.posicion = null;
          }
        }
      }
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.columnafiltrada[name];
      return $dirty ? !$error : null;
    },
    agregarOrden() {
      this.columnaOrdenar = {
        columna: null,
        ordena: null,
      };
      this.tituloModalAgrupamiento = "Crear Orden";
      this.showAgrupamiento = true;
      if (this.listaAsc.length === 0 && this.listaDesc.length === 0) {
        this.listaColumnasDisponibles = JSON.parse(
            JSON.stringify(this.filtrosAgregar)
        );
      }
    },
    cerrarModalOrden() {
      this.showAgrupamiento = false;
    },
    cerrarModalOrdenEditar() {
      this.showAgrupamientoEditar = false;
    },
    verificando() {
      if (this.listaFiltros.length > 0) {
        this.listaFiltros.map((item, index) => {
          let exite = false;
          this.filtrosAgregar.map((columna) => {
            if (columna.nombreColumna === item.columna) {
              exite = true;
            }
          });
          if (!exite) {
            this.listaFiltros.splice(index, 1);
          }
        });
      }
      this.verificandoAsc();
      this.verificandoDesc();
      this.verificandoGroup();
      this.actualizaColumnas();
      this.verificandoGrafica();
      this.validarColGrafica();
    },
    verificandoDesc() {
      this.listaDesc.map((item, index) => {
        let exite = false;
        this.filtrosAgregar.map((columna) => {
          if (columna.nombreColumna === item.columna) {
            exite = true;
          }
        });
        if (!exite) {
          this.listaDesc.splice(index, 1);
        }
      });
    },
    verificandoAsc() {
      this.listaAsc.map((item, index) => {
        let exite = false;
        this.filtrosAgregar.map((columna) => {
          if (columna.nombreColumna === item.columna) {
            exite = true;
          }
        });
        if (!exite) {
          this.listaAsc.splice(index, 1);
        }
      });
    },
    verificandoGroup() {
      this.listaAgroup.map((item, index) => {
        let exite = false;
        this.filtrosAgregar.map((columna) => {
          if (columna.nombreColumna === item.nombreColumna) {
            exite = true;
          }
        });
        if (!exite) {
          this.listaAgroup.splice(index, 1);
        }
      });
    },
    reporte() {
      this.mostrarGrafica = false;
      this.loaderTabla = true;
      this.mostraTabla = false;
      this.existeDatos = false;
      let listaColumnas = [];
      let listaFiltros = [];
      this.listaGraficaX =[];
      this.listaGraficaY=[];

      this.datosTabla = [];
      this.paginaActual=1;
      
      for (let i = 0; i < this.filtrosAgregar.length; i++) {
        listaColumnas.push({
          vista: this.filtrosAgregar[i].nombreVista,
          columna: this.filtrosAgregar[i].nombreColumna,
          operador: "",
          valor: "",
          tipo_dato: this.filtrosAgregar[i].tipoDeDato,
          agrupa: "true",
          ordena: "ASC",
          gruop: "false",
        });
      }
      if (this.listaFiltros.length > 0) {
        for (let j = 0; j < this.listaFiltros.length; j++) {
          // for (let f = 0; f < listaColumnas.length; f++) {
            // if (this.listaFiltros[j].columna == listaColumnas[f].columna) {
            //   listaColumnas.splice(f, 1);
              listaFiltros.push(
                  JSON.parse(JSON.stringify(this.listaFiltros[j]))
              );
            // }
          // }
        }
      }
      if (this.listaAsc.length > 0) {
        for (let d = 0; d < this.listaAsc.length; d++) {
          for (let c = 0; c < listaColumnas.length; c++) {
            if (this.listaAsc[d].columna === listaColumnas[c].columna) {
              listaColumnas[c].ordena = "ASC";
            }
          }
        }
      }
      if (this.listaDesc.length > 0) {
        for (let r = 0; r < this.listaDesc.length; r++) {
          for (let f = 0; f < listaColumnas.length; f++) {
            if (this.listaDesc[r].columna === listaColumnas[f].columna) {
              listaColumnas[f].ordena = "DESC";
            }
          }
        }
      }
      if (this.listaAgroup.length > 0) {
        for (let x = 0; x < this.listaAgroup.length; x++) {
          for (let h = 0; h < listaColumnas.length; h++) {
            if (this.listaAgroup[x].nombreColumna == listaColumnas[h].columna) {
              listaColumnas[h].gruop = "true";
            }
          }
        }
      }
      for (let n = 0; n < listaColumnas.length; n++) {
        if (listaColumnas[n].tipo_dato == "date") {
          let valorfecha = listaColumnas[n].valor;
          listaColumnas[n].tipo_dato = "date";
          listaColumnas[n].valor = "'" + valorfecha + "'";
        }
      }
      for (let r = 0; r < listaColumnas.length; r++) {
        if (
            listaColumnas[r].tipo_dato == "character varying" ||
            listaColumnas[r].tipo_dato == "text"
        ) {
          let valorfecha = listaColumnas[r].valor;
          listaColumnas[r].valor = "'" + "%" + valorfecha + "%" + "'";
        }
      }
      let listOrdenada = [];
      this.filtrosAgregar.map((item) => {
        listaColumnas.map((columna) => {
          if (item.nombreColumna === columna.columna) {
            listOrdenada.push(columna);
          }
        });
      });
      this.obtenenerColumnas(listOrdenada, listaFiltros);
    },
    agregarOdern() {
      if (this.valSelect) {
        if (this.listaColumnasDisponibles.length === 0) {
          this.$swal({
            icon: "error",
            text: "No hay columnas que seleccionar",
          });
        } else if (this.columnaOrdenar.ordena == null) {
          this.$swal({
            icon: "error",
            text: "Debe seleccionar un orden para realizar el filtro",
          });
        } else if (this.columnaOrdenar.columna == null) {
          this.$swal({
            icon: "error",
            text: "Debe seleccionar una columna para realizar el filtro ",
          });
        } else {
          switch (this.columnaOrdenar.ordena) {
            case "ASC":
              this.listaAsc.push(this.columnaOrdenar);
              this.listaAsc.map((item) => {
                this.listaColumnasDisponibles.map((columna, index) => {
                  if (columna.nombreColumna === item.columna) {
                    this.listaColumnasDisponibles.splice(index, 1);
                  }
                });
              });
              this.cerrarModalOrden();
              break;
            case "DESC":
              this.listaDesc.push(this.columnaOrdenar);
              this.listaDesc.map((item) => {
                this.listaColumnasDisponibles.map((columna, index) => {
                  if (columna.nombreColumna === item.columna) {
                    this.listaColumnasDisponibles.splice(index, 1);
                  }
                });
              });
              this.cerrarModalOrden();
              break;
          }
        }
      } else {
        if (this.listAux.length === 0) {
          this.$swal({
            icon: "error",
            text: "No hay columnas seleccionadas",
          });
        } else {
          if (this.listaAgroup.length > 0) {
            this.listAux.map((columna) => {
              let exite = false;
              this.listaAgroup.map((item) => {
                if (columna.nombreColumna === item.nombreColumna) {
                  exite = true;
                }
              });
              if (!exite) {
                this.listaAgroup.push(columna);
              }
            });
          } else {
            this.listaAgroup = this.listAux;
          }
          this.cerrarModalOrden();
          this.valSelect = true;
        }
      }
    },
    editarOrden(index, numero) {
      this.posicionOrden = index;
      this.columnaOrdenar = {
        columna: null,
        ordena: null,
      };
      this.tituloModalAgrupamientoEditar = "Modificar Ordenar";
      this.showAgrupamientoEditar = true;
      switch (numero) {
        case 1:
          this.columnaOrdenar = JSON.parse(
              JSON.stringify(this.listaAsc[index])
          );
          this.ordenaAux = this.listaAsc[index].ordena;

          break;
        case 2:
          this.columnaOrdenar = JSON.parse(
              JSON.stringify(this.listaDesc[index])
          );
          this.ordenaAux = this.listaDesc[index].ordena;
      }
    },
    guardarOrdenEditar() {
      if (this.columnaOrdenar.columna == null) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar una columna para realizar el filtro ",
        });
      } else if (this.columnaOrdenar.ordena == null) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar un orden para realizar el filtro",
        });
      } else {
        switch (this.columnaOrdenar.ordena) {
          case "ASC":
            if (this.ordenaAux !== this.columnaOrdenar.ordena) {
              this.listaDesc.splice(this.posicionOrden, 1);
              this.listaAsc.push(this.columnaOrdenar);
            }
            this.cerrarModalOrdenEditar();
            break;
          case "DESC":
            if (this.ordenaAux !== this.columnaOrdenar.ordena) {
              this.listaAsc.splice(this.posicionOrden, 1);
              this.listaDesc.push(this.columnaOrdenar);
            }
            this.cerrarModalOrdenEditar();
            break;
        }
      }
    },
    eliminarOrden(index, numero) {
      let orden = null;
      switch (numero) {
        case 1:
          orden = this.listaAsc[index];
          this.filtrosAgregar.map((item) => {
            if (orden.columna === item.nombreColumna) {
              this.listaColumnasDisponibles.push(item);
            }
          });
          this.listaAsc.splice(index, 1);
          orden = null;
          break;
        case 2:
          orden = this.listaDesc[index];
          this.filtrosAgregar.map((item) => {
            if (orden.columna === item.nombreColumna) {
              this.listaColumnasDisponibles.push(item);
            }
          });
          this.listaDesc.splice(index, 1);
          orden = null;
          break;
        case 3:
          this.listaAgroup.splice(index, 1);
          orden = null;
          break;
      }
    },
    actualizaColumnas() {
      if (this.listaAsc.length > 0 || this.listaDesc.length > 0) {
        this.filtrosAgregar.map((item) => {
          let exite1 = false;
          let exite2 = false;
          this.listaAsc.map((columna) => {
            if (item.nombreColumna === columna.columna) {
              exite1 = true;
            }
          });
          this.listaDesc.map((columna) => {
            if (item.nombreColumna === columna.columna) {
              exite1 = true;
            }
          });
          if (!exite1 && !exite2) {
            this.listaColumnasDisponibles.push(item);
          }
        });
      }
    },
    validarSelect() {
      if (
          this.columnaOrdenar.ordena === "ASC" ||
          this.columnaOrdenar.ordena === "DESC"
      ) {
        this.valSelect = true;
      } else {
        this.valSelect = false;
      }
    },
    eliminarFiltroCompleto(numero) {
      switch (numero) {
        case 1:
          this.listaAsc = [];
          break;
        case 2:
          this.listaDesc = [];
          break;
        case 3:
          this.listaAgroup = [];
          break;
      }
    },
    seleccionarTodos() {
      this.filtrosAgregar = this.listaColumnas;
    },
    verificandoGrafica() {
      if(this.listaGraficaX.length > 0){
      this.listaGraficaX.map((item, index) => {
        let exite = false;
        this.filtrosAgregar.map((columna) => {
          if (columna.nombreColumna === item.nombreColumna) {
            exite = true;
          }
        });
        if (!exite) {
          this.listaGraficaX.splice(index, 1);
        }
      });
      }
    },
    generarGrafica() {
      this.mostrarGrafica = false;
      let listaAux = [];
      let listaAux2 = [];
      listaAux.push(this.listaGraficaX);
      listaAux2.push(this.columnSeleccionadoY);
      let nombre = listaAux[0].nombreColumna;
      let nombre2 = listaAux2[0].nombreColumna;

      this.datoColumnaX = nombre;
      this.columnaxTO = [];
      this.columnayTO = {};

      if (listaAux.length > 0) {
        // if (listaAux2[0].tipoDeDato === 'bigint' || listaAux2[0].tipoDeDato === 'integer' || listaAux2[0].tipoDeDato === 'double precision') {
          this.datosTabla.forEach((element) => {
            if(this.columnaxTO.indexOf(element[nombre]) < 0) {
              this.columnaxTO.push(element[nombre]);
            }
          })

          // const columnayTOTMP = [];
          // // if (this.columnaxTO.length>0) {
          //   this.columnaxTO.forEach(col => {
          //     const arregloDatos = this.datosTabla.filter(it => it[nombre] === col).map(it => it[nombre2]);
          //     if (columnayTOTMP[col] === undefined) {
          //       columnayTOTMP[col] = {}
          //     }
          //     columnayTOTMP[col].label = col;
          //     columnayTOTMP[col].data = arregloDatos;
          //     // this.columnayTO.push(Math.max.apply(Math, arregloDatos));
          //   });
          // }
        this.columnayTO = [];
        this.datosTabla.forEach(it => {
          this.columnayTO.push({label: it[nombre], data: it[nombre2]});
        });
        // datasets: [
        //   {
        //     label: this.columnaY.label,
        //     backgroundColor: "#f87979",
        //     data: this.columnaY.data
        //   }
        // ]


          this.mostrarGrafica = true;
        // } else {
        //   this.mostrarGrafica = false;
        //   this.$swal({
        //     icon: "error",
        //     text: "Debe seleccionar una columna numerica para Y",
        //   });
        // }
      }
    },
    columnVerificarX() {
      let listaY = [];
      this.listaGraficaY = [];
      listaY.push(this.listaGraficaX);
      listaY.map((item) => {
        this.filtrosAgregar.map((columna) => {
          if (columna.nombreColumna !== item.nombreColumna) {
            this.listaGraficaY.push(columna);
          }
        });
      });
    },
    validarColGrafica(){
      if(this.filtrosAgregar.length >= 2){
        this.muestraTabsGrafica = false;
      }else{
      this.mostraTabla = false;
      this.mostrarGrafica = false;
      this.columnSeleccionadoX = [];
      this.columnSeleccionadoY = [];
      this.listaGraficaX = [];
      this.listaGraficaY =[];
      this.muestraTabsGrafica = true;
      this.columnaxTO = [];
      this.columnayTO =  [];
      this.existeDatos = true;
      }
    }
  },
};
</script>
